"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SlicedReviewItemSchema = exports.ExceptionReviewDecisionSchema = void 0;
const z = require("zod");
const consensus_types_1 = require("../../../../Consensus/consensus.types");
exports.ExceptionReviewDecisionSchema = z.object({
    sliceKey: z.string(),
    anchor: consensus_types_1.AnchorSchema,
    shouldExist: z.boolean().optional(),
    value: z.unknown().optional(),
    isOverride: z.boolean(),
});
exports.SlicedReviewItemSchema = z.object({
    sliceKey: z.string(),
    item: consensus_types_1.ReviewItemSchema,
});
//# sourceMappingURL=exception-review.types.js.map